// extracted by mini-css-extract-plugin
export var alignBaseline = "_m-9";
export var alignCenter = "_m-5";
export var alignFlexEnd = "_m-7";
export var alignFlexStart = "_m-6";
export var alignSelfBaseline = "_m-e";
export var alignSelfCenter = "_m-a";
export var alignSelfFlexEnd = "_m-c";
export var alignSelfFlexStart = "_m-b";
export var alignSelfStretch = "_m-d";
export var alignStretch = "_m-8";
export var column = "_m-2";
export var columnReverse = "_m-4";
export var flex = "_m-0";
export var justifyCenter = "_m-f";
export var justifyFlexEnd = "_m-h";
export var justifyFlexStart = "_m-g";
export var justifySpaceAround = "_m-j";
export var justifySpaceBetween = "_m-i";
export var justifySpaceEvenly = "_m-k";
export var row = "_m-1";
export var rowReverse = "_m-3";
export var wrapNowrap = "_m-m";
export var wrapWrap = "_m-l";
export var wrapWrapReverse = "_m-n";